// @ts-ignore
import request, { ApiResponse } from "@/utils/request";

// 定义接口参数类型
export interface DebugGetApiParams {
  [key: string]: any;
}

export interface DebugPostApiData {
  [key: string]: any;
}

export interface WechatSignatureParams {
  [key: string]: any;
}

export interface SMSCodeParams {
  [key: string]: any;
}

export interface LoginApiData {
  [key: string]: any;
}

export interface TrackEventData {
  [key: string]: any;
}

export interface SubmitFusionPersonData {
  sourceUrl: string;
  templatePk: string;
  [key: string]: any;
}

export interface QueryFusionResultParams {
  taskId: string;
}

export interface GetCityTemplateParams {
  cityName: string;
}

// 定义响应数据类型
export interface DebugApiResponse {
  [key: string]: any;
}

export interface WechatSignatureResponse {
  [key: string]: any;
}

export interface SMSCodeResponse {
  [key: string]: any;
}

export interface LoginApiResponse {
  [key: string]: any;
}

export interface TrackEventResponse {
  [key: string]: any;
}

export interface SubmitFusionPersonResponse {
  code: string;
  data?: {
    taskId: string;
  };
  msg?: string;
}

export interface QueryFusionResultResponse {
  code: string;
  data?: {
    status: 'success' | 'failed' | 'processing';
    cardUrl?: string;
    msg?: string;
  };
}

export interface GetCityTemplateResponse {
  code: string;
  data?: {
    templateList: Array<{
      templatePk: string;
      [key: string]: any;
    }>;
  };
}

/**
 * 调试接口模块
 */
export const debugApi = {
  // GET测试接口
  debugGetApiAuth(params: DebugGetApiParams): Promise<ApiResponse<DebugApiResponse>> {
    return request.get(`/v1/debugGetApiAuth`, params);
  },

  // POST测试接口
  debugPostApiAuth(data: DebugPostApiData): Promise<ApiResponse<DebugApiResponse>> {
    return request.post("/v1/debugPostApiAuth?key1=hellotest&key2=12345", data);
  },

  // 获取微信签名
  getWechatSignature(params: WechatSignatureParams): Promise<ApiResponse<WechatSignatureResponse>> {
    return request.post("/v1/wechatJsapi/ticket", params);
  },

  // 获取短信验证码
  getSMSCode(params: SMSCodeParams): Promise<ApiResponse<SMSCodeResponse>> {
    return request.post("/v1/sms/getSmsCode", params);
  },

  // 登录接口
  loginApi(data: LoginApiData): Promise<ApiResponse<LoginApiResponse>> {
    return request.post("/v1/user/mobileLogin", data);
  },

  // 埋点统计
  trackEvent(data: TrackEventData): Promise<ApiResponse<TrackEventResponse>> {
    return request.post("/v1/act/behaviorReport", data);
  },

  // 提交人脸融合人物
  submitFusionPerson(data: SubmitFusionPersonData): Promise<ApiResponse<SubmitFusionPersonResponse>> {
    return request.post("/faceswap/v1/submitTask", data);
  },

  // 查询人脸融合结果
  queryFusionResult(params: QueryFusionResultParams): Promise<ApiResponse<QueryFusionResultResponse>> {
    return request.get("/faceswap/v1/queryTaskResult?taskId=" + params.taskId);
  },

  // 获取城市模版
  getCityTemplate(params: GetCityTemplateParams): Promise<ApiResponse<GetCityTemplateResponse>> {
    return request.get("/faceswap/v1/templateList?city=" + params.cityName);
  },
};
